import * as React from 'react';
export var OffersContext = /*#__PURE__*/React.createContext({
  layout: {},
  addOfferToComparison: function addOfferToComparison() {},
  removeOfferFromComparison: function removeOfferFromComparison() {},
  addOfferToFavorites: function addOfferToFavorites() {},
  removeOfferFromFavorites: function removeOfferFromFavorites() {}
});